
/**
 * 트윗 유형
 */
export type TweetCreateRequestMetadataTweetType = typeof TweetCreateRequestMetadataTweetType[keyof typeof TweetCreateRequestMetadataTweetType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TweetCreateRequestMetadataTweetType = {
  ORIGINAL: 'ORIGINAL',
  REPLY: 'REPLY',
  QUOTE: 'QUOTE',
  RETWEET: 'RETWEET',
} as const;
